export const API_CONFIG = {
  /**
   * @deprecated Client should use /api/proxy instead to avoid exposing backend URL
   * This is kept for backwards compatibility but should not be used in client code
   */
  CLIENT_BASE_URL: process.env.NEXT_PUBLIC_API_URL!,
  /**
   * Server-side base URL for backend API
   * Used by server components and proxy route
   * This should NOT be exposed to the client
   */
  SERVER_BASE_URL: process.env.API_BASE_URL!,
  DEFAULT_HEADERS: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/json",
    // Backend requires an explicit API version on the search/filter endpoints
    "x-api-version": "1",
    "Accept-Encoding": "gzip, deflate, br",
    "Accept-Language": "en-US,en;q=0.9,fa;q=0.8",
    Connection: "keep-alive",
    "Sec-Ch-Ua-Mobile": "?0",
    "Sec-Ch-Ua-Platform": "Windows",
    "Sec-Fetch-Dest": "empty",
    "Sec-Fetch-Mode": "cors",
    "Sec-Fetch-Site": "cross-site",
  },
} as const;
